import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const ImpersonateCallback: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const processTokens = async () => {
      try {
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const searchParams = new URLSearchParams(window.location.search);
        const params = hashParams.get('access_token') ? hashParams : searchParams;
        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token');

        if (!accessToken || !refreshToken) {
          setError('Missing session tokens');
          return;
        }

        // Set the session in Supabase client
        const { error: sessionError } = await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
        });

        if (sessionError) {
          console.error('Failed to set session:', sessionError);
          setError('Failed to establish session');
          return;
        }

        const { data: userData, error: userError } = await supabase.auth.getUser(accessToken);

        if (userError || !userData.user) {
          console.error('Failed to verify impersonated session:', userError);
          setError('Failed to verify session');
          return;
        }

        window.history.replaceState({}, document.title, '/auth/impersonate');
        window.location.replace('/dashboard');
      } catch (err) {
        console.error('Impersonate callback error:', err);
        setError('An unexpected error occurred');
      }
    };

    processTokens();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <a href="/login" className="text-indigo-600 hover:text-indigo-900">
            Go to Login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600" />
        <p className="text-gray-600">Signing in...</p>
      </div>
    </div>
  );
};

export default ImpersonateCallback;
